document.addEventListener('DOMContentLoaded', function() {
    const voteButton = document.querySelector('[data-js-vote-button]');
    const voteContainer = document.querySelector('[data-js-vote-container]');
    const popup = document.querySelector('.nw-product-vote-popup');
    const closeTriggers = document.querySelectorAll('[data-js-vote-popup-close]');
    const submitButton = document.querySelector('[data-js-vote-submit]');
    const emailInput = document.getElementById('nw-product-vote-popup-content-email');
    
    // Google Apps Script Web App URL
    const GOOGLE_SCRIPT_URL = voteContainer.getAttribute('data-sheet-url');
    
    // Check if user has already voted for this product
    if (submitButton && voteContainer) {
        const productId = submitButton.getAttribute('data-product-id');
        const productName = submitButton.getAttribute('data-product-name');
        
        if (hasUserVoted(productId, productName)) {
            // User has already voted, disable the vote container
            voteContainer.classList.add('nw-product-vote-disabled');
        }
    }

    // Open popup when vote button is clicked
    if (voteButton && popup) {
        voteButton.addEventListener('click', function() {
            // Check if voting is disabled
            if (voteContainer && voteContainer.classList.contains('nw-product-vote-disabled')) {
                return; // Don't open popup if already voted
            }
            popup.classList.add('active');
            document.body.classList.add('modal-opened');
        });
    }

    // Close popup when close triggers are clicked (close button and overlay)
    if (popup && closeTriggers.length > 0) {
        closeTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', function() {
                popup.classList.remove('active');
                document.body.classList.remove('modal-opened');
            });
        });
    }

    // Handle vote submission
    if (submitButton && emailInput) {
        submitButton.addEventListener('click', function() {
            const email = emailInput.value.trim();
            const productName = submitButton.getAttribute('data-product-name');
            const productId = submitButton.getAttribute('data-product-id');

            // Validate email
            if (!email || !isValidEmail(email)) {
                alert('Please enter a valid email address');
                return;
            }

            // Show loading state
            submitButton.classList.add('working');
            submitButton.disabled = true;

                         // First check if user has already voted for this product
             checkExistingVote(productId, productName, email)
             .then(hasVoted => {
                 if (hasVoted) {
                     alert('You have already voted for this product!');
                     // Store vote in localStorage even for duplicates (for this device)
                     storeUserVote(productId, productName);
                     // Disable vote container on this device too
                     if (voteContainer) {
                         voteContainer.classList.add('nw-product-vote-disabled');
                     }
                     // Clear the form and close popup
                     emailInput.value = '';
                     popup.classList.remove('active');
                     document.body.classList.remove('modal-opened');
                     // Remove loading state
                     submitButton.classList.remove('working');
                     submitButton.disabled = false;
                     return;
                 }

                 // If no existing vote, proceed with submission
                 submitVote(productId, productName, email);
             })
                         .catch(error => {
                 console.error('Error checking existing vote:', error);
                 alert('Error checking vote status. Please try again.');
                 // Remove loading state
                 submitButton.classList.remove('working');
                 submitButton.disabled = false;
             });
        });
    }

    // Email validation function
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Check if user has already voted for this product (server-side check)
    function checkExistingVote(productId, productName, email) {
        const checkUrl = `${GOOGLE_SCRIPT_URL}?action=checkVote&productId=${encodeURIComponent(productId)}&productName=${encodeURIComponent(productName)}&userEmail=${encodeURIComponent(email)}`;
        
        return fetch(checkUrl)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    return data.hasVoted;
                } else {
                    throw new Error(data.error || 'Error checking vote status');
                }
            });
    }

    // Submit vote to Google Sheet
    function submitVote(productId, productName, email) {
        const formData = new FormData();
        formData.append('productId', productId);
        formData.append('productName', productName);
        formData.append('userEmail', email);

        return fetch(GOOGLE_SCRIPT_URL, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Store vote in localStorage
                storeUserVote(productId, productName);
                // Disable vote container
                if (voteContainer) {
                    voteContainer.classList.add('nw-product-vote-disabled');
                }
                // Clear the form and close popup
                emailInput.value = '';
                popup.classList.remove('active');
                document.body.classList.remove('modal-opened');
            } else {
                alert('Error submitting vote: ' + (data.error || 'Unknown error'));
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Error submitting vote. Please try again.');
        })
        .finally(() => {
            // Remove loading state
            submitButton.classList.remove('working');
            submitButton.disabled = false;
        });
    }

    // LocalStorage functions for vote tracking
    function hasUserVoted(productId, productName) {
        const votedProducts = JSON.parse(localStorage.getItem('nw-voted-products') || '[]');
        return votedProducts.some(vote => vote.productId === productId && vote.productName === productName);
    }

    function storeUserVote(productId, productName) {
        const votedProducts = JSON.parse(localStorage.getItem('nw-voted-products') || '[]');
        const voteData = {
            productId: productId,
            productName: productName,
            votedAt: new Date().toISOString()
        };
        votedProducts.push(voteData);
        localStorage.setItem('nw-voted-products', JSON.stringify(votedProducts));
    }
});
